<button class="close-button-modal-fixed" mat-mini-fab (click)="cancel()">
    <mat-icon aria-label="Close Dialog">close</mat-icon>
</button>

<div mat-dialog-content style="padding-top: 25px;">
    <app-tabitpay-ticket-seated [$storage]="$storage"></app-tabitpay-ticket-seated>
</div>

